(ns common.schema.entities.survey-cycle.options)

(def cycle-status-options
  [{:key :survey-cycle.status/draft
    :label "Draft"}
   {:key :survey-cycle.status/active
    :label "Active"}
   {:key :survey-cycle.status/closed
    :label "Closed"}])
